import { render, staticRenderFns } from "./addAccount.vue?vue&type=template&id=52b22593&"
import script from "./addAccount.vue?vue&type=script&lang=js&"
export * from "./addAccount.vue?vue&type=script&lang=js&"
import style0 from "./addAccount.vue?vue&type=style&index=0&id=52b22593&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports